import { useContext } from 'react';

import { SubmitRequestPage } from '@zg-rentals/rental-manager-env';

import { RMWContext } from '../../providers/RMWContext';

import { UserSelectors } from '../../selectors';
import { useSelector } from '../../selectors/useSelector';

import accessUtils from '../../utils/accessUtils';

import SubmitRequestPageZRM from '../SubmitRequestPage';

export const SubmitRequestWrapper = () => {
  const { paths } = useContext(RMWContext);

  const user = useSelector((state) => UserSelectors.makeUser(state));
  const { appConfig } = useSelector((state) => state.app);

  const zrmSignInPage = paths.zrmSignInPage(`${paths.submitRequest}`) || undefined;

  const SubmitRequestComponent = accessUtils.canAccessNewRequestForm({ appConfig })
    ? () => <SubmitRequestPage zrmwUser={user} zrmSignInPage={zrmSignInPage} />
    : SubmitRequestPageZRM;

  return <SubmitRequestComponent />;
};
